export default "__VITE_ASSET__B$NJGxlx__"